import { useState } from 'react';
import { Button, Flex, Select } from '@radix-ui/themes';

import * as Types from '@/types';
import NodeContainer from '../../Container';
import { NodeInput } from '../../../inputs';
import { WorkflowNodeProps } from '../..';

export type DefaultNodeProps = WorkflowNodeProps<Types.ActionNode> & {
  onCancel: () => void;
};

const ActionTypeSelect = ({
  actionType,
  onChange,
}: {
  actionType: Types.ActionType | undefined;
  onChange: (actionType: Types.ActionType) => void;
}) => (
  <Select.Root
    value={actionType}
    onValueChange={(value) => onChange(value as Types.ActionType)}
  >
    <Select.Trigger placeholder="Select Type" />
    <Select.Content>
      {Object.entries(Types.ActionType).map(([key, value]) => (
        <Select.Item key={key} value={value}>
          {key}
        </Select.Item>
      ))}
    </Select.Content>
  </Select.Root>
);

const DefaultNode = ({ id, data, onChange, onCancel }: DefaultNodeProps) => {
  const [actionType, setActionType] = useState<Types.ActionType | undefined>(
    undefined,
  );

  const handleSave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!actionType) return;

    onChange(id, {
      action: {
        ...data.action,
        actionType,
      },
    });
  };

  return (
    <NodeContainer title="New Action">
      <Flex direction="column" gap="2" p="2">
        <NodeInput title="Action Type">
          <ActionTypeSelect actionType={actionType} onChange={setActionType} />
        </NodeInput>
        <Flex justify="between">
          <Button variant="ghost" size="1" m="2" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="ghost" size="1" m="2" onClick={handleSave}>
            Save
          </Button>
        </Flex>
      </Flex>
    </NodeContainer>
  );
};

export default DefaultNode;
